export function TrashIcon({ className }: { className?: string }) {
	return (
		<svg
			viewBox='0 0 12.9333 14.2667'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path
				d='M11.1333 3.13333V12.4667C11.1333 12.8203 10.9929 13.1594 10.7428 13.4095C10.4928 13.6595 10.1536 13.8 9.8 13.8H3.13333C2.77971 13.8 2.44057 13.6595 2.19052 13.4095C1.94048 13.1594 1.8 12.8203 1.8 12.4667V3.13333M0.466667 3.13333H12.4667M3.8 3.13333V1.8C3.8 1.44638 3.94048 1.10724 4.19052 0.857191C4.44057 0.607142 4.77971 0.466667 5.13333 0.466667H7.8C8.15362 0.466667 8.49276 0.607142 8.74281 0.857191C8.99286 1.10724 9.13333 1.44638 9.13333 1.8V3.13333'
				stroke='currentColor'
				strokeWidth={0.933333}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}
